import { IonText } from '@ionic/react';
import { ReactNode } from 'react';

import styles from '@components/typography/Typography.module.css';
import { Colors } from '@utils/colorUtils';

type Props = {
  children: ReactNode;
  color: Colors;
};

const TagText = ({ children, color }: Props) => (
  <IonText className={styles.tagText} color={color}>
    {children}
  </IonText>
);

export default TagText;
